import { useGetPershingEligibility } from '@packages/api-client/hooks/identity';

/**
 * Warms the React Query cache with feature-flag-like data that action
 * classes read synchronously via `queryClient.getQueryData()`.
 *
 * Each flag query uses `staleTime: Infinity` — fired once per session.
 * Add new flags here as needed; the guard pattern keeps them colocated.
 */
export function useFeatureFlagsGuard(): void {
  useGetPershingEligibility();
}
